import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Switch as ChakraSwitch,
  SwitchProps,
} from '@chakra-ui/react';
import {
  FieldErrors,
  FieldValues,
  Path,
  UseFormRegister,
} from 'react-hook-form';

interface ToggleButtonProps<TFields extends FieldValues>
  extends SwitchProps {
  name: Path<TFields>;
  label: string;
  register: UseFormRegister<TFields>;
  errors?: FieldErrors<TFields>;
}

export function ToggleButton<TFields extends FieldValues>({
  name,
  label,
  value,
  children,
  errors,
  register,
  ...props
}: ToggleButtonProps<TFields>) {
  const isInvalid = errors ? !!errors[name] : false;
  const errorMessage = errors ? errors[name]?.message : '';

  return (
    <FormControl id={props.id} isInvalid={isInvalid}>
      <FormLabel aria-label={label} htmlFor={props.id}>
        {label}
      </FormLabel>
      <ChakraSwitch
        value={value}
        aria-label={name}
        {...register(name)}
        {...props}
      >
        {children}
      </ChakraSwitch>
      <FormErrorMessage>{errorMessage as string}</FormErrorMessage>
    </FormControl>
  );
}

export default ToggleButton;
